<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    content-class="sc-modal sc-modal--sm"
  >
    <template v-slot:activator="{ on, attrs }">
      <div class="table-action-box" v-bind="attrs" v-on="on">
        <v-icon small>mdi-pencil</v-icon>
        <span class="table-action-label">Editar</span>
      </div>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-cog</v-icon>
        <div>
          <span class="sc-modal__title">Editar configuração</span>
          <span class="sc-modal__subtitle">Intervalo e frequência de atualização dos resultados</span>
        </div>
      </div>

      <div class="sc-modal__body">
        <div class="enquete-config-row">
          <div class="sc-modal__field enquete-config-grow">
            <label class="sc-modal__field-label">Hora início</label>
            <v-text-field
              v-model="startHour"
              type="text"
              inputmode="numeric"
              maxlength="2"
              solo flat dense
              hide-details
              background-color="surface_tertiary"
              placeholder="0"
              suffix="h"
              @input="startHour = clampHour(startHour)"
              @blur="startHour = padHour(startHour)"
              @keydown.native="onHourKeydown('startHour', $event)"
              @wheel.native="onHourWheel('startHour', $event)"
            />
          </div>
          <div class="sc-modal__field enquete-config-grow">
            <label class="sc-modal__field-label">Hora fim</label>
            <v-text-field
              v-model="endHour"
              type="text"
              inputmode="numeric"
              maxlength="2"
              solo flat dense
              hide-details
              background-color="surface_tertiary"
              placeholder="0"
              suffix="h"
              @input="endHour = clampHour(endHour)"
              @blur="endHour = padHour(endHour)"
              @keydown.native="onHourKeydown('endHour', $event)"
              @wheel.native="onHourWheel('endHour', $event)"
            />
          </div>
        </div>
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Atualizar a cada</label>
          <v-select
            solo flat dense
            hide-details
            v-model="selectedUpdateTime"
            :items="availableTimes"
            item-text="name"
            item-value="value"
            return-object
            background-color="surface_tertiary"
            placeholder="Selecione"
          />
        </div>
      </div>

      <div class="sc-modal__footer">
        <v-btn text @click="dialog = false" class="modal-btn-cancel">Cancelar</v-btn>
        <v-btn
          color="primary"
          @click.prevent="salvarConfigUpdateEnquete"
          :loading="loading"
          class="modal-btn-confirm"
        >
          <v-icon small class="mr-1">mdi-check</v-icon>
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { apiClient } from "../../../services/api";
export default {
  name: "EditarConfiguracaoUpdateEnquetes",
  props: {
    configData: Object,
    idCategoria: Number,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      startHour: "",
      endHour: "",
      selectedUpdateTime: null,
      availableTimes: [
        { name: "10 seg", value: 10 },
        { name: "1 min", value: 60 },
        { name: "3 min", value: 180 },
        { name: "5 min", value: 300 },
        { name: "10 min", value: 600 },
        { name: "15 min", value: 900 },
        { name: "30 min", value: 1800 },
      ],
    };
  },
  watch: {
    dialog(open) {
      if (open) this.seedFromConfig();
    },
  },
  created() {
    this.seedFromConfig();
  },
  methods: {
    seedFromConfig() {
      this.startHour = this.padHour(this.configData.start_hour);
      this.endHour = this.padHour(this.configData.end_hour);
      this.selectedUpdateTime =
        this.availableTimes.find((t) => t.value === this.configData.seconds_interval) || null;
    },
    ...mapActions({
      getCategorias: "enquetes/getCategoriasEnquetes",
    }),
    clampHour(v) {
      if (v === "" || v === null || v === undefined) return "";
      const digits = String(v).replace(/\D/g, "");
      if (digits === "") return "";
      return String(Math.max(0, Math.min(23, parseInt(digits, 10))));
    },
    padHour(v) {
      const clamped = this.clampHour(v);
      return clamped === "" ? "" : clamped.padStart(2, "0");
    },
    stepHour(current, delta) {
      const base = this.clampHour(current);
      if (base === "") return this.padHour(0);
      return this.padHour((parseInt(base, 10) + delta + 24) % 24);
    },
    onHourKeydown(field, e) {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        this[field] = this.stepHour(this[field], 1);
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        this[field] = this.stepHour(this[field], -1);
      }
    },
    onHourWheel(field, e) {
      // Mirror native number inputs: only step while the field is focused.
      if (!e.currentTarget.contains(document.activeElement)) return;
      e.preventDefault();
      this[field] = this.stepHour(this[field], e.deltaY < 0 ? 1 : -1);
    },
    async salvarConfigUpdateEnquete() {
      if (this.startHour === "" || this.endHour === "") {
        this.$toast.error("Preencha hora início e hora fim");
        return;
      }
      const start = Number(this.startHour);
      const end = Number(this.endHour);
      if (
        Number.isNaN(start) || Number.isNaN(end) ||
        start < 0 || start > 23 || end < 0 || end > 23
      ) {
        this.$toast.error("Horas devem estar entre 0 e 23");
        return;
      }
      if (start === end) {
        this.$toast.error("Hora inicial e hora final não podem ser iguais");
        return;
      }
      const elapsed = end > start ? end - start : (24 - start) + end;
      if (elapsed > 12) {
        this.$toast.error("Intervalo de no máximo 12 horas");
        return;
      }
      const seconds =
        typeof this.selectedUpdateTime === "object" && this.selectedUpdateTime !== null
          ? this.selectedUpdateTime.value
          : Number(this.selectedUpdateTime);

      if (Number.isNaN(seconds)) {
        this.$toast.error("Selecione um tempo de atualização válido");
        return;
      }

      this.loading = true;
      try {
        await apiClient.patch(
          `enquetes/categorias/${this.idCategoria}/config/${this.configData.id}`,
          {
            start_hour: Number(this.startHour),
            end_hour: Number(this.endHour),
            seconds_interval: seconds,
          }
        );
        await this.getCategorias({ page: 1, size: 100 });
        this.$toast.success("Configuração atualizada com sucesso");
        this.dialog = false;
      } catch (err) {
        const apiMessage = err?.response?.data?.error;
        this.$toast.error(apiMessage || "Erro ao atualizar configuração.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.enquete-config-row {
  display: flex;
  gap: 12px;
}

.enquete-config-grow {
  flex: 1;
}
</style>
